const CardItem = ({card, handleSelectCard}) => {
  return (
            <div className="accounts-container27">
              <div className="accounts-container28">
                <div className="accounts-container29">
                  <h4 className="accounts-text22">{card.card.type} ending {card.card.last_4digits}</h4>
                </div>
                <div className="accounts-container30">
                  <span>Expiring  {card.card.expiry}</span>
                </div>
              </div>

              <button className="accounts-button3 button" onClick={()=> {handleSelectCard(card.id)}}>Select</button>
            </div>
  )
}


export default CardItem;
